import { Tabs } from '@mantine/core';
import { ReactElement } from 'react';
import { useSearchParams } from 'react-router';
import { ConsultationsTab } from './Consultations/ConsultationsTab';
import { ScheduleTab } from './Schedule/ScheduleTab';
import { SchedulerTab } from './Scheduler/SchedulerTab';
import { TimeBlocksTab } from './TimeBlocks/TimeBlocksTab';

const TABS = ['time-blocks', 'schedule', 'scheduler', 'consultations'] as const;
type ProcedureSchedulingTab = (typeof TABS)[number];
const DEFAULT_TAB: ProcedureSchedulingTab = 'time-blocks';

function isValidTab(value: string | null): value is ProcedureSchedulingTab {
  return value !== null && (TABS as readonly string[]).includes(value);
}

export function ProcedureSchedulingPage(): ReactElement {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const activeTab = isValidTab(tabParam) ? tabParam : DEFAULT_TAB;

  const handleTabChange = (value: string | null): void => {
    if (!isValidTab(value)) {
      return;
    }
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set('tab', value);
      return next;
    });
  };

  return (
    <Tabs value={activeTab} onChange={handleTabChange} keepMounted={false}>
      <Tabs.List>
        <Tabs.Tab value="time-blocks">Time Blocks</Tabs.Tab>
        <Tabs.Tab value="schedule">Schedule</Tabs.Tab>
        <Tabs.Tab value="scheduler">Scheduler</Tabs.Tab>
        <Tabs.Tab value="consultations">Upcoming Consultations</Tabs.Tab>
      </Tabs.List>
      <Tabs.Panel value="time-blocks">
        <TimeBlocksTab />
      </Tabs.Panel>
      <Tabs.Panel value="schedule">
        <ScheduleTab />
      </Tabs.Panel>
      <Tabs.Panel value="scheduler">
        <SchedulerTab />
      </Tabs.Panel>
      <Tabs.Panel value="consultations">
        <ConsultationsTab />
      </Tabs.Panel>
    </Tabs>
  );
}
